import { http } from "@/api";
import AgreggateOption from "@/constants/generating-unit-status/GeneratingUnitStatusAggregateOptions";

const Qs = require("qs");

/**
 * Solicita os status das unidades geradoras agregados por Plantas Hidroelétricas ou Baias.
 * @param {Number} companyId Id da empresa detentora do ativo
 * @param {String} aggregateBy Tipo de agregação para a solicitação.
 * @returns Array com status das unidade geradoras agregadas pelo tipo de agregação.
 */
const GetAggregated = function(companyId = 0, aggregateBy = AgreggateOption.WIND_PARK)
{
	const queryParams = {
		companyId,
		aggregateBy,
	};

	return http.get("/GeneratingUnitsStatus/Aggregated",
		{
			params:           queryParams,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Solicita os status de uma unidades geradoras.
 * @param {Number} mtId Conjunto de ids do elemento de monitração do tipo unidade geradora.
 * @returns Os status de uma unidade geradora consulta.
 */
const Get = function(mtId)
{
	return http.get(`/GeneratingUnitsStatus/${mtId}`);
};

export default
{
	GetAggregated,
	Get
};